enum PromoInfoRoutes {
  PromoInfoList = '/content-settings/promo-info',
  PromoInfoAdd = '/content-settings/promo-info/add',
  PromoInfoEdit = '/content-settings/promo-info/:id',
}

export default PromoInfoRoutes
